module.exports = __webpack_public_path__ + "media/react/shared/components/true_link/main/google-play-store-5a2befc71dfc99c7af14f3c9f23e6083.svg";